// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import customTable from '../../../../../share/components/vue/PaginationTable';
import customProgress from "../../../../../share/components/vue/CustomProgress";
import config from '../../../../../share/config';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import { readHistoryData } from './standby';
import { readImageData } from './start';
import { exitLogic } from './terminate';
import { PHASE } from './constants';

const moment = require('moment');

export default {
  name: 'requirementSpMCAM001',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      confirmChecked: false,
      agreementChecked: false,
      progress: 0,
      progressMax: 100,
      estimatedTime: 0,
      selectedItem: null,
      selectedStoreItem: null,
      historyData: {},
      displayHistoryInfo: [],
      historyInfoTableColumns: [],
      storeHistory: [],
      displayStoreHistoryInfo: [],
      storeHistoryInfoTableColumns: [],
      doneFile: 0,
      fileAmount: 0,
      modal_special_requirement_MCAM1: false
    };
  },

  components: {
    'custom-Progress': customProgress,
    "custom-table": customTable
  },

  props: {
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.ERROR:
          return 'danger';
        case PHASE.START:
        case PHASE.ALERT_HISTORY_DATA:
          return 'warning';
        case PHASE.HISTORY_VIEW:
        case PHASE.STORE_HISTORY_VIEW:
        case PHASE.READ_HISTORY_DATA:
        case PHASE.STORE_FILE:
        default:
          return 'secondary';
      }
    },
    // チェックボックスが2つとも押下されない限りtrue(PHASE.START)
    isDisabledAgreementConfirm() {
      if (!this.confirmChecked || !this.agreementChecked) return true;
      return false;
    },
    isDisableButton() {
      if (this.selectedItem === null) return true;
      return false;
    },
    isDisableOkButton() {
      if (this.displayStoreHistoryInfo.length <= 0) return true;
      return false;
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_special_requirement_MCAM1 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.resetSelectItem();
      this.$emit('close-wizard');
      this.modal_special_requirement_MCAM1 = false;
    },

    /** 警告表示から履歴情報表示へ遷移 */
    async screenMovement() {
      try {
        // スピナー表示
        this.isLoading = true;
        // 履歴読み出し
        await readHistoryData(this);
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 履歴情報の表示用変換
     * @returns 表示用履歴情報
     */
    historyInfoTableDataConvert() {
      // カラム設定
      this.historyInfoTableColumns = [
        {
          name: "displayName",
          label: "individual.header_history",
        }
      ];

      // 一覧データの設定（履歴有無に関わらず表示するため、一覧データは固定とする）
      return [
        {
          displayName: this.$t(`individual.wide_angle_mono_camera_primary_secondary_non_operation_history`),
          typeKey: ['primary_brake', 'secondary_brake', 'inoperable']
        },
        {
          displayName: this.$t(`individual.wide_angle_mono_camera_alarm_operation_history`),
          typeKey: ['alarm']
        }
      ];
    },

    /**
     * 履歴情報テーブルの行選択時のイベント
     * @param {object} rowData 選択された行データ
     */
    historyRowClick(rowData) {
      this.selectedItem = rowData;
      this.displayHistoryInfo.forEach((item) => {
        if (item.displayName === this.selectedItem.displayName) {
          item.fieldSpec = {};
          item.fieldSpec.displayName = config.LIST_ITEM_HIGHLIGHT;
        } else if (item.fieldSpec) {
          delete item.fieldSpec;
        }
      });
    },

    /** 履歴情報表示から保存履歴表示へ遷移 */
    async selectHistory() {
      this.phase = PHASE.STORE_HISTORY_VIEW;
      // 保存履歴の表示用変換
      this.storeHistory = this.storeHistoryInfoTableDataConvert();
      this.displayStoreHistoryInfo = [];
      // 保存履歴表示の一覧を描画
      this.$nextTick(() => {
        this.displayStoreHistoryInfo = this.storeHistory.filter(data => data.isShowList);
      });
    },

    /** 
     * 保存履歴の表示用変換
     * @returns 表示用保存履歴情報
     */
    storeHistoryInfoTableDataConvert() {
      // カラムの設定
      this.storeHistoryInfoTableColumns = [
        {
          name: "preservationTarget",
          label: `individual.header_preservation_target`,
        },
        {
          name: "storeItem",
          label: `individual.header_store_item`,
        },
        {
          name: "date",
          label: `individual.header_vehicle_dtc_table_date_time_occurrence`,
        },
        {
          name: "igon",
          label: "message.header_vehicle_dtc_table_igon_counts",
        }
      ];

      const storeHistoryArr = [];
      // 一覧データの設定
      for (const typeKey of this.selectedItem.typeKey) {
        // 種別情報の取得
        const targetTypeInfo = this.historyData[`aeb_history_data`][typeKey];
        // 種別が存在しない場合、スキップ
        if (!targetTypeInfo) {
          continue;
        }
        // 種別に紐づく orderKey の取得
        const orderKeys = Object.keys(targetTypeInfo);
        // 種別のkeyが存在しない場合、スキップ
        if (orderKeys.length === 0) {
          continue;
        }
        // orderKeys のループ
        for (const orderKey of orderKeys) {
          const storeHistory = {
            preservationTarget: '*',
            storeItem: this.selectedItem.displayName,
            date: '-',
            igon: targetTypeInfo[orderKey].igon,
            typeKey: typeKey,
            orderKey: orderKey,
            isShowList: targetTypeInfo[orderKey].igon !== null
          };
          storeHistoryArr.push(storeHistory);
        }
      }
      return storeHistoryArr;
    },

    /** 保存履歴表示から履歴データ読み出し警告へ遷移 */
    async saveHistory() {
      // 1レコード辺りの所要時間は0.5分(30秒)
      this.estimatedTime = Math.ceil(this.storeHistory.length * 30 / 60);
      // ファイルの総量は選択したレコードのlength
      this.fileAmount = this.storeHistory.length;
      this.phase = PHASE.ALERT_HISTORY_DATA;
    },

    /** 履歴データ読み出しを実行する */
    async execute() {
      try {
        this.doneFile = 1;
        this.isLoading = true;
        this.phase = PHASE.READ_HISTORY_DATA;
        // データ読み出し用変数
        let nextReadDid = '';
        let downloadUuid = '';
        let fileUrl = '';
        let isLastRecord = this.storeHistory.length === 1;
        let savedTotalFileSize = 0;

        do {
          // レコードの先頭のデータを取得する
          const targetRecord = this.storeHistory[0];
          const response = await readImageData(targetRecord, nextReadDid, downloadUuid, isLastRecord, savedTotalFileSize, this);
          // レスポンスが存在しない場合、またはPhaseが"PHASE.READ_HISTORY_DATA"以外の場合、エラーに倒れたので処理を中断
          if (!response || this.phase !== PHASE.READ_HISTORY_DATA) {
            return;
          }
          const readResult = response.data.user_data;
          this.progress = readResult.progress;
          fileUrl = readResult.fileUrl;
          // nextReadDidが存在しない場合、1履歴分のデータ読み出しが完了と判断
          if (!readResult.nextReadDid) {
            // fileURLが存在する場合、ファイルをDLする
            if (fileUrl) {
              await this.readResultOutputFile(fileUrl, readResult.fileExtension);
            }
            // 取得した先頭のレコードを削除する
            this.storeHistory.shift();
            // まだ読み出すデータが残っている場合、完了ファイル数を+1し、
            // 次に取得するDIDとプログレス値を初期化する
            if (this.storeHistory.length > 0) {
              this.doneFile++;
              nextReadDid = '';
              this.progress = 0;
              // 1履歴分のデータの合計サイズを加算しておく
              savedTotalFileSize = readResult.totalFileSize;
              // 履歴のlengthが残り1の場合、最後のレコードと判断する
              isLastRecord = this.storeHistory.length === 1;
            }
          } else {
            // レスポンスで返却された次に取得するDIDとダウンロード用uuidを設定する
            nextReadDid = readResult.nextReadDid;
            downloadUuid = readResult.downloadUuid;
          }
          // レコードのlengthが0以下になるまでループする
        } while (this.storeHistory.length > 0);
        // 全てのデータ読み出しが完了し、現在のphaseがエラーでなければ成功画面に遷移する
        if (this.phase !== PHASE.ERROR) {
          this.phase = PHASE.SUCCESS;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * ファイル出力
     * @param {string} fileUrl preSignedURL
     * @param {string} fileExtension ファイル拡張子
     */
    async readResultOutputFile(fileUrl, fileExtension) {
      try {
        //ファイル名を変更
        const formattedDate = moment().format("YYYYMMDDHHmmss");

        //URLからファイルをダウンロード
        await fetch(fileUrl)
          .then((response) => response.blob())
          .then((myBlob) => {
            const objUrl = URL.createObjectURL(myBlob);
            const link = document.createElement("a");
            link.href = objUrl;
            link.download = formattedDate + "." + fileExtension;
            link.click();
            link.remove();
            URL.revokeObjectURL(objUrl);
          })
          .catch(() => {
            this.phase = PHASE.ERROR;
          });
      } catch {
        this.phase = PHASE.ERROR;
      }
    },

    /**
     * エラー発生時の表示
     * @returns 
     */
    async showUnexpectedError() {
      // 共通エラー画面の場合、ダイアログを閉じる
      if (this.phase === PHASE.ERROR) {
        this.closeWizard();
        return;
      }
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /**
     * 任意の画面に戻る
     * @param {string} dst フェーズ情報
     */
    backTo(dst) {
      // 画面遷移
      this.phase = dst;
      // 画面遷移度に、画面に合わせた表示の初期化を行う
      switch (dst) {
        case PHASE.HISTORY_VIEW:
          this.$nextTick(() => {
            this.resetSelectItem(PHASE.HISTORY_VIEW);
          });
          break;
        case PHASE.STORE_HISTORY_VIEW:
          this.$nextTick(() => {
            this.resetSelectItem(PHASE.STORE_HISTORY_VIEW);
          });
          break;
        default:
          break;
      }
    },

    /**
     * 表示している画面の選択された行データのリセット
     */
    async resetSelectItem() {
      switch (this.phase) {
        case PHASE.HISTORY_VIEW:
          this.displayHistoryInfo.forEach(item => {
            if (item.fieldSpec) {
              delete item.fieldSpec;
            }
          });
          this.displayHistoryInfo = this.historyInfoTableDataConvert();
          this.selectedItem = null;
          break;
        case PHASE.STORE_HISTORY_VIEW:
          this.storeHistory = this.storeHistoryInfoTableDataConvert();
          this.displayStoreHistoryInfo = this.storeHistory.filter(data => data.isShowList);
          break;
        default:
          break;
      }
    },

    /** 終了処理 */
    async exitLogic() {
      await exitLogic(this);
    },
  },

  async mounted() {
    this.init();
  },
};